// extracted by mini-css-extract-plugin
export var listItem = "CustomLists-module--listItem--4277f";
export var root = "CustomLists-module--root--573b0";